<template>
    <div v-if="reservation && transactionsView" class="pt-1">
        <b-button-toolbar v-if="reservationEdit" class="pt-4">
            <responsive-button
                class="mr-2"
                v-if="userHasPayPal"
                :icon="['fab', 'paypal']"
                variant="outline-primary"
                :responsiveness="false"
                :withSpace="false"
                :disabled="!processBilling || reservation.airbnb_messaging_api || reservation.vrbo_messaging_api"
                @click="showSendPayPalInvoiceEmailModal"
            >
                Paypal Invoice
            </responsive-button>
            <responsive-button
                class="mr-2"
                v-if="!userHasPayPal && !processPaymentDisabled"
                :icon="['fas', 'credit-card']"
                variant="outline-primary"
                :responsiveness="false"
                :withSpace="false"
                :disabled="processPaymentDisabled"
                @click="processPayment"
            >
                Process Payment
            </responsive-button>
            <responsive-button
                class="second-button mr-2"
                v-if="!userHasPayPal && !processPreAuthDisabled"
                :icon="['fas', 'credit-card']"
                variant="outline-primary"
                :responsiveness="false"
                :withSpace="false"
                :disabled="processPreAuthDisabled"
                @click="processPreAuth"
            >
                Process PreAuth
            </responsive-button>
            <responsive-button
                class="third-button mr-2"
                v-if="!processPaymentDisabled"
                :icon="['far', 'credit-card']"
                variant="outline-primary"
                :responsiveness="false"
                :withSpace="false"
                @click="recordPayment"
            >
                Record Payment
            </responsive-button>
            <responsive-button
                class="forth-button mr-2"
                v-if="!processPaymentDisabled"
                :icon="['far', 'credit-card']"
                variant="outline-primary"
                :responsiveness="false"
                :withSpace="false"
                @click="recordRefund"
            >
                Record Refund
            </responsive-button>
            <responsive-button
                class="fifth-button mr-2"
                v-if="!userHasPayPal && !processPaymentDisabled"
                :icon="['far', 'credit-card']"
                variant="outline-primary"
                :responsiveness="false"
                :withSpace="false"
                @click="recordPreAuth"
            >
                Record PreAuth
            </responsive-button>
            <responsive-button
                class="mr-2"
                v-if="processPaymentDisabled"
                :icon="['far', 'credit-card']"
                variant="outline-primary"
                :responsiveness="false"
                :withSpace="false"
                @click="recordPayment"
            >
                Record Payment
            </responsive-button>
            <responsive-button
                class="second-button mr-2"
                v-if="processPaymentDisabled"
                :icon="['far', 'credit-card']"
                variant="outline-primary"
                :responsiveness="false"
                :withSpace="false"
                @click="recordRefund"
            >
                Record Refund
            </responsive-button>
            <responsive-button
                class="third-button mr-2"
                v-if="!userHasPayPal && processPaymentDisabled"
                :icon="['far', 'credit-card']"
                variant="outline-primary"
                :responsiveness="false"
                :withSpace="false"
                @click="recordPreAuth"
            >
                Record PreAuth
            </responsive-button>
            <responsive-button
                class="forth-button mr-2"
                v-if="!userHasPayPal && processPaymentDisabled"
                :icon="['fas', 'credit-card']"
                variant="outline-primary"
                :responsiveness="false"
                :withSpace="false"
                :disabled="processPaymentDisabled"
                @click="processPayment"
            >
                Process Payment
            </responsive-button>
            <responsive-button
                class="fifth-button mr-2"
                v-if="!userHasPayPal && processPreAuthDisabled"
                :icon="['fas', 'credit-card']"
                variant="outline-primary"
                :responsiveness="false"
                :withSpace="false"
                :disabled="processPreAuthDisabled"
                @click="processPreAuth"
            >
                Process PreAuth
            </responsive-button>
            <responsive-button
                class="sixth-button mr-2"
                v-if="!userHasPayPal"
                :icon="['fas', 'wallet']"
                variant="outline-primary"
                :responsiveness="false"
                :withSpace="false"
                :disabled="!reservation.can_send_payment_request"
                @click="showPaymentRequestModal"
            >
                Request Payment
            </responsive-button>
            <responsive-button
                class="seventh-button mr-2"
                v-if="manageCredits && metadata.has_guest_credit_enabled"
                :icon="['far', 'credit-card']"
                variant="outline-primary"
                :responsiveness="false"
                :withSpace="false"
                @click="guestCredit"
            >
                Guest Credit
            </responsive-button>
            <responsive-button
                class="eighth-button mr-2"
                v-if="!userHasPayPal && userVirtualTerminalUrl"
                :icon="['fas', 'money-check-dollar']"
                :href="userVirtualTerminalUrl"
                variant="outline-primary"
                :disabled="!processBilling"
                :responsiveness="false"
                :withSpace="false"
                target="_blank"
            >
                Virtual Terminal
            </responsive-button>
            <b-button-group class="more-filters-dropdown">
                <more-filters-dropdown variant="outline-primary">
                        <responsive-button
                            class="second-button-dropdown text-left"
                            v-if="!userHasPayPal && !processPreAuthDisabled"
                            :icon="['fas', 'credit-card']"
                            variant="outline-primary"
                            :responsiveness="false"
                            :withSpace="false"
                            :disabled="processPreAuthDisabled"
                            @click="processPreAuth"
                        >
                            Process PreAuth
                        </responsive-button>
                        <responsive-button
                            class="third-button-dropdown text-left"
                            v-if="!processPaymentDisabled"
                            :icon="['far', 'credit-card']"
                            variant="outline-primary"
                            :responsiveness="false"
                            :withSpace="false"
                            @click="recordPayment"
                        >
                            Record Payment
                        </responsive-button>
                        <responsive-button
                            class="forth-button-dropdown text-left"
                            v-if="!processPaymentDisabled"
                            :icon="['far', 'credit-card']"
                            variant="outline-primary"
                            :responsiveness="false"
                            :withSpace="false"
                            @click="recordRefund"
                        >
                            Record Refund
                        </responsive-button>
                        <responsive-button
                            class="fifth-button-dropdown text-left"
                            v-if="!userHasPayPal && !processPaymentDisabled"
                            :icon="['far', 'credit-card']"
                            variant="outline-primary"
                            :responsiveness="false"
                            :withSpace="false"
                            @click="recordPreAuth"
                        >
                            Record PreAuth
                        </responsive-button>
                        <responsive-button
                            class="second-button-dropdown text-left"
                            v-if="processPaymentDisabled"
                            :icon="['far', 'credit-card']"
                            variant="outline-primary"
                            :responsiveness="false"
                            :withSpace="false"
                            @click="recordRefund"
                        >
                            Record Refund
                        </responsive-button>
                        <responsive-button
                            class="third-button-dropdown text-left"
                            v-if="!userHasPayPal && processPaymentDisabled"
                            :icon="['far', 'credit-card']"
                            variant="outline-primary"
                            :responsiveness="false"
                            :withSpace="false"
                            @click="recordPreAuth"
                        >
                            Record PreAuth
                        </responsive-button>
                        <responsive-button
                            class="forth-button-dropdown text-left"
                            v-if="!userHasPayPal && processPaymentDisabled"
                            :icon="['fas', 'credit-card']"
                            variant="outline-primary"
                            :responsiveness="false"
                            :withSpace="false"
                            :disabled="processPaymentDisabled"
                            @click="processPayment"
                        >
                            Process Payment
                        </responsive-button>
                        <responsive-button
                            class="fifth-button-dropdown text-left"
                            v-if="!userHasPayPal && processPaymentDisabled"
                            :icon="['fas', 'credit-card']"
                            variant="outline-primary"
                            :responsiveness="false"
                            :withSpace="false"
                            :disabled="processPreAuthDisabled"
                            @click="processPreAuth"
                        >
                            Process PreAuth
                        </responsive-button>
                        <responsive-button
                            class="sixth-button-dropdown text-left"
                            v-if="!userHasPayPal"
                            :icon="['fas', 'wallet']"
                            variant="outline-primary"
                            :responsiveness="false"
                            :withSpace="false"
                            :disabled="!reservation.can_send_payment_request"
                            @click="showPaymentRequestModal"
                        >
                            Request Payment
                        </responsive-button>
                        <responsive-button
                            class="seventh-button-dropdown text-left"
                            v-if="manageCredits && metadata.has_guest_credit_enabled"
                            :icon="['far', 'credit-card']"
                            variant="outline-primary"
                            :responsiveness="false"
                            :withSpace="false"
                            @click="guestCredit"
                        >
                            Guest Credit
                        </responsive-button>
                        <responsive-button
                            class="eighth-button-dropdown text-left"
                            v-if="!userHasPayPal && userVirtualTerminalUrl"
                            :icon="['fas', 'money-check-dollar']"
                            :href="userVirtualTerminalUrl"
                            variant="outline-primary"
                            :disabled="!processBilling"
                            :responsiveness="false"
                            :withSpace="false"
                            target="_blank"
                        >
                            Virtual Terminal
                        </responsive-button>
                </more-filters-dropdown>
            </b-button-group>
            <span
                class="text-danger ml-4 mt-5"
                v-if="reservation.no_credit_card_warning && !reservation.process_payment_data"
            >
                Credit Card data not received, invalid or incomplete. Please contact guest to obtain data.
            </span>
        </b-button-toolbar>
        <grid
            ref="grid"
            class="guest-invoices-grid pt-2"
            overlayNoRowsTemplate="No transactions"
            :getRowClass="getRowClass"
            :columnDefs="columnDefs"
            :rowData="reservation.transactions"
            :headerHeight="45"
            :paginationPageSize="6"
            :pagination="true"
            :isAutoWidth="true"
            :isAutoHeight="true"
            :isSearch="false"
            :with-space="false"
        >
        </grid>
        <div class="reservation-notes" v-if="showReservationNotes">
            <b-row>
                <b-col>
                    <b>Notes:</b>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    {{ reservation.notes }}
                </b-col>
            </b-row>
        </div>
        <reservation-payment-modal
            :modal-id="paymentModalId"
            :initial-values="reservation"
            :onUpdate="onModalUpdate"
            :type="billType"
            :mode="billMode"
        />
        <guest-credit-modal :modalId="guestCreditModalId" :reservation="reservation" :onUpdate="onModalUpdate" />
        <payment-request-modal
            :modalId="requestPaymentModalId"
            :company="metadata.subscriber.company"
            :reservation="reservation"
            :onUpdate="onModalUpdate"
        />
        <reservation-send-email-modal
            :modal-id="sendEmailModalId"
            :initial-values="reservation"
            :selected-report-template="selectedReportTemplate"
            :onUpdate="onModalUpdate"
        />
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import API from '../../../../../api.jsx';
import Grid from '../../../../generic/grid/grid.vue';
import Modal from '../../../../generic/modal/modal.vue';
import BusyModal from '../../../../generic/busy-modal/busy-modal.vue';
import FormFile from '../../../../generic/form-file/form-file.vue';
import FormInput from '../../../../generic/form-input/form-input.vue';
import FormSelect from '../../../../generic/form-select/form-select.vue';
import FormCheckbox from '../../../../generic/form-checkbox/form-checkbox.vue';
import ResponsiveButton from '../../../../generic/responsive-button/responsive-button.vue';
import MoreFiltersDropdown from '../../../../generic/more-filters-dropdown/more-filters-dropdown.vue';
import ReservationPaymentModal from '../../../../common/reservation-payment-modal.vue';
import ReservationSendEmailModal from '../../../../common/reservation-send-email-modal.vue';
import TransactionPaymentMethodCellRenderer from '../../../../generic/grid/transaction-payment-method-cell-renderer.vue';
import GuestCreditModal from './guest-credit-modal.vue';
import PaymentRequestModal from './payment-request-modal.vue';
import ActionCellRenderer from './action-cell-renderer.vue';
import { formatResponseError } from '../../../../../utils/api';
import {
    GUEST_RESERVATION_CHECK_BILL_STATUS_CHANGE_ENDPOINT,
    RESERVATION_INVOICE_REPORT_TEMPLATES_ENDPOINT,
} from '../../../../../endpoints.js';
import {
    PAYMENT_METHOD_CONFIRMATION_STATUS_CONFIRMED,
    TRANSACTION_VARIANT_AUTOMATED_PAYMENT_NOTIFICATION,
    TRANSACTION_VARIANT_AUTOMATED_PAYMENT_PREDICTION,
} from '../../../../../constants';

export default {
    name: 'GuestInvoicesTransactionsTab',
    components: {
        Grid,
        Modal,
        BusyModal,
        FormFile,
        FormInput,
        FormSelect,
        FormCheckbox,
        ResponsiveButton,
        GuestCreditModal,
        PaymentRequestModal,
        MoreFiltersDropdown,
        ReservationPaymentModal,
        ReservationSendEmailModal,
        transactionPaymentMethodCellRenderer: TransactionPaymentMethodCellRenderer,
        actionCellRenderer: ActionCellRenderer,
    },
    data() {
        return {
            billType: 0,
            billMode: 'RECORD',
            paymentModalId: 'payment-modal-id',
            sendEmailModalId: 'send-email-modal-id',
            requestPaymentModalId: 'request-payment-modal-id',
            guestCreditModalId: 'guest-credit-modal-id',
            selectedReportTemplate: null,
            emailMode: 'PAYPAL',
        };
    },
    inject: ['showErrorToast'],
    mounted() {
        Promise.all([this.fetchAutomatedPaymentSettings(), this.fetchReportTemplates()]);
    },
    computed: {
        ...mapGetters('guest', ['metadata', 'reservation']),
        ...mapGetters('header', ['userHasPayPal', 'userHasPreauth', 'userVirtualTerminalUrl']),
        guestId() {
            return parseInt(this.$route.params.id);
        },
        isECheck() {
            return this.reservation.process_payment_data?.profile_type == 1 || false;
        },
        reservationEdit() {
            return this.metadata?.permissions?.reservation_edit;
        },
        processBilling() {
            return this.metadata?.permissions?.billing_process;
        },
        transactionsView() {
            return this.metadata?.permissions?.transactions_view;
        },
        manageCredits() {
            return this.metadata?.permissions?.manage_credits;
        },
        processPaymentDisabled() {
            return (
                !this.reservation.process_payment_data ||
                !this.processBilling ||
                this.reservation.payment_method_confirmation_status !== PAYMENT_METHOD_CONFIRMATION_STATUS_CONFIRMED ||
                this.reservation.is_process_payment_disabled
            );
        },
        processPreAuthDisabled() {
            return (
                !this.reservation.process_payment_data ||
                !this.userHasPreauth ||
                !this.processBilling ||
                this.reservation.payment_method_confirmation_status !== PAYMENT_METHOD_CONFIRMATION_STATUS_CONFIRMED ||
                (this.isECheck && this.metadata.use_setup_intent_guest)
            );
        },
        columnDefs() {
            return [
                {
                    field: 'date',
                    headerName: 'Date',
                    type: 'dateTimeColumn',
                },
                {
                    field: 'operation',
                    headerName: 'Operation',
                    minWidth: 120,
                },
                {
                    field: 'sum_paid',
                    headerName: 'Amount',
                    type: 'amountColumn',
                    minWidth: 100,
                },
                {
                    field: '',
                    headerName: 'Method',
                    sortable: false,
                    minWidth: 250,
                    cellRenderer: 'transactionPaymentMethodCellRenderer',
                    cellRendererParams: {
                        refresh: async (id) => {
                            await this.checkBillStatusChange(id);
                        },
                    },
                },
                {
                    field: 'notes',
                    headerName: 'Notes',
                    autoHeight: true,
                    cellRenderer: ({ data }) => data && data.notes && data.notes.split('\n').join('<br/>'),
                    autoWidthExclude: !this.isMobile,
                },
                {
                    field: '',
                    headerName: '',
                    editable: false,
                    sortable: false,
                    minWidth: 130,
                    maxWidth: 130,
                    cellStyle: { display: 'flex', justifyContent: 'flex-end' },
                    cellRendererParams: {
                        refreshReservation: this.refreshReservation,
                    },
                    cellRenderer: 'actionCellRenderer',
                    hide: !this.reservationEdit,
                },
            ];
        },
        showReservationNotes() {
            return this.reservation?.notes?.length;
        },
        isMobile() {
            const md = 768;
            return window.innerWidth < md || window.innerHeight < md;
        },
    },
    methods: {
        async fetchAutomatedPaymentSettings() {
            try {
                await this.$store.dispatch('paymentGateway/fetchAutomatedPaymentSettings');
            } catch (e) {
                const { generic } = formatResponseError(e);
                this.errorToast({ text: generic || 'Could not fetch automated payment settings.' });
            }
        },
        getRowClass({ data }) {
            if (data.variant === TRANSACTION_VARIANT_AUTOMATED_PAYMENT_PREDICTION) {
                return 'automated-payment-prediction';
            } else if (data.variant === TRANSACTION_VARIANT_AUTOMATED_PAYMENT_NOTIFICATION) {
                return 'automated-payment-notification';
            }
            return '';
        },
        recordPayment() {
            this.billMode = 'RECORD';
            this.billType = 0;
            this.$bvModal.show(this.paymentModalId);
        },
        recordRefund() {
            this.billMode = 'RECORD';
            this.billType = 1;
            this.$bvModal.show(this.paymentModalId);
        },
        recordPreAuth() {
            this.billMode = 'RECORD';
            this.billType = 2;
            this.$bvModal.show(this.paymentModalId);
        },
        processPayment() {
            this.billMode = 'PROCESS';
            this.billType = 0;
            this.$bvModal.show(this.paymentModalId);
        },
        processRefund() {
            this.billMode = 'PROCESS';
            this.billType = 1;
            this.$bvModal.show(this.paymentModalId);
        },
        processPreAuth() {
            this.billMode = 'PROCESS';
            this.billType = 2;
            this.$bvModal.show(this.paymentModalId);
        },
        guestCredit() {
            this.$bvModal.show(this.guestCreditModalId);
        },
        showSendPayPalInvoiceEmailModal() {
            this.selectedReportTemplate = this.reportTemplates.find(
                (item) => item.default_report_type_name === 'PayPal Invoice'
            );
            this.$bvModal.show(this.sendEmailModalId);
        },
        onModalUpdate() {
            this.$emit('refreshReservations');
        },
        refreshReservation(callback) {
            this.$emit('refreshReservations', callback);
        },
        showPaymentRequestModal() {
            this.$bvModal.show(this.requestPaymentModalId);
        },
        readAsDataURL(file) {
            return new Promise((resolve, reject) => {
                const fr = new FileReader();
                fr.onerror = reject;
                fr.onload = function() {
                    resolve(fr.result);
                };
                fr.readAsDataURL(file);
            });
        },
        async checkBillStatusChange(pk) {
            this.$emit('loading', true);
            try {
                await API.post(GUEST_RESERVATION_CHECK_BILL_STATUS_CHANGE_ENDPOINT(this.guestId), { pk: pk });
                this.$emit('refreshReservations');
            } catch (err) {
                if (err?.response?.status == 409) {
                    this.warningToast({
                        text: `Payment status not changed. Please wait a few seconds or
                         return to this invoice later to check if payment status has been updated.`,
                    });
                } else {
                    const { generic } = formatResponseError(err);
                    this.showErrorToast({
                        text: generic || `Could not check bill status.`,
                    });
                }
            } finally {
                this.$emit('loading', false);
            }
        },
        async fetchReportTemplates() {
            try {
                const { data } = await API.get(RESERVATION_INVOICE_REPORT_TEMPLATES_ENDPOINT());
                this.reportTemplates = [{ id: null, report_name: 'Message' }];
                if (!this.reservation.airbnb_messaging_api && !this.reservation.vrbo_messaging_api) {
                    this.reportTemplates = this.reportTemplates.concat(data);
                }
            } catch (err) {
                this.showErrorToast({ text: 'Could not load report template.' });
            }
        },
    },
};
</script>
<style lang="scss" scoped>
@import '../../guest-invoices-grid.scss';

.reservation-notes {
    word-break: break-word;
    margin-left: 0.4rem;
    max-width: 45rem;
}

button.second-button {
    @media (max-width: 450px) {
        display: none !important;
    }
}

button.second-button-dropdown {
    @media (min-width: 451px) {
        display: none !important;
    }
}

button.third-button {
    @media (max-width: 870px) {
        display: none !important;
    }
}

button.third-button-dropdown {
    @media (min-width: 871px) {
        display: none !important;
    }
}

button.forth-button {
    @media (max-width: 992px) {
        display: none !important;
    }
}

button.forth-button-dropdown {
    @media (min-width: 993px) {
        display: none !important;
    }
}

button.fifth-button {
    @media (max-width: 1100px) {
        display: none !important;
    }
}

button.fifth-button-dropdown {
    @media (min-width: 1101px) {
        display: none !important;
    }
}

button.sixth-button {
    @media (max-width: 1280px) {
        display: none !important;
    }
}

button.sixth-button-dropdown {
    @media (min-width: 1281px) {
        display: none !important;
    }
}

button.seventh-button {
    @media (max-width: 1420px) {
        display: none !important;
    }
}

button.seventh-button-dropdown {
    @media (min-width: 1421px) {
        display: none !important;
    }
}

a.eighth-button {
    @media (max-width: 1550px) {
        display: none !important;
    }
}

.more-filters-dropdown,
a.eighth-button-dropdown {
    @media (min-width: 1551px) {
        display: none !important;
    }
}

:deep(.automated-payment-prediction) {
    background: linear-gradient(90deg, rgba(146, 254, 157, 0.06) 0%, rgba(0, 201, 255, 0.06) 100%) !important;
}
:deep(.automated-payment-notification) {
    background: linear-gradient(90deg, rgba(255, 78, 80, 0.1) 0%, rgba(249, 212, 35, 0.1) 100%) !important;
}
</style>
